/**
 * Route definitions for the crypto payins SPA.
 *
 * Routes:
 *   PAY    /pay/:sessionHash    → Pay flow
 *   SETUP  /setup/:sessionHash  → Setup flow
 *   CATCH_ALL *                → 404
 */

const routes = {
  PAY: '/pay/:sessionHash',
  SETUP: '/setup/:sessionHash',
  CATCH_ALL: '*',
} as const;

export default routes;

type RouteParams = {
  PAY: {params: {sessionHash: string}};
  SETUP: {params: {sessionHash: string}};
  CATCH_ALL: {params?: {glob?: string[]}};
};

declare global {
  // eslint-disable-next-line @typescript-eslint/no-empty-interface
  interface SailNavigationRouteParams extends RouteParams {}
}
